import FormContainer from "../../../../components/formContainer/FormContainer";
import InputWrapper from "../../../../components/input/wrapper/InputWrapper";
import HiddenLoader from "../../../../components/loader/HiddenLoader/HiddenLoader";
import OverlayLoader from "../../../../components/loader/OverlayLoader/OverlayLoader";
import Select from "../../../../components/select/main/Select";
import { useLanguageContext } from "../../../../context/LanguageContext";
import EVAApiHelper from "../../../../helpers/EVAApiHelper";
import { StyledAltButton } from "../../../../styles/ButtonStyles";
import { StyledInput } from "../../../../styles/InputStyles";
import { StyledFlexColumn } from "../../../../styles/LayoutStyles";
import PrintLabel from "../label_editor/label/PrintLabel";

function FormView({
  printerData,
  fields,
  images,
  printerDevices,
  onNameChange,
  onDpiChange,
  onRotateChange,
  onPrinterDeviceChange,
  onCancel,
  onSubmit,
  onPrint,
  submitError,
}) {
  const { translate } = useLanguageContext();

  return (
    <OverlayLoader groups={"printer_page_fetch"}>
      <FormContainer
        onCancel={onCancel}
        onSubmit={onSubmit}
        submitError={submitError}
        submitLoadingGroup={"printer_page_submit"}
        actions={
          <HiddenLoader groups={"printer_page_print"}>
            <StyledAltButton
              disabled={printerData.label_items.length === 0}
              onClick={onPrint}
            >
              {translate("eva.main.general.print")}

              <PrintLabel
                printerData={printerData}
                fields={fields}
                images={images}
                readOnly={true}
              />
            </StyledAltButton>
          </HiddenLoader>
        }
      >
        <StyledFlexColumn>
          <InputWrapper
            label={translate("eva.main.validation.attributes.name")}
            required
            error={EVAApiHelper.getResponseError("name", submitError)}
          >
            <StyledInput
              type="text"
              value={printerData.name}
              onChange={onNameChange}
              placeholder={translate("eva.main.validation.attributes.name")}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.dpi")}
            required
            error={EVAApiHelper.getResponseError("dpi", submitError)}
          >
            <Select
              value={printerData.dpi}
              onChange={onDpiChange}
              options={[
                { value: 152, label: "152 DPI" },
                { value: 203, label: "203 DPI" },
                { value: 300, label: "300 DPI" },
                { value: 600, label: "600 DPI" },
              ]}
            />
          </InputWrapper>

          <InputWrapper
            label={translate(
              "eva.main.validation.attributes.printer_device_id",
            )}
            error={EVAApiHelper.getResponseError(
              "printer_device_id",
              submitError,
            )}
          >
            <Select
              value={printerData.printer_device_id}
              onChange={onPrinterDeviceChange}
              options={printerDevices.map((device) => ({
                value: device.id,
                label: device.name + " (" + device.deviceName + ")",
              }))}
              nullable
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.rotate")}
            error={EVAApiHelper.getResponseError("rotate", submitError)}
          >
            <Select
              value={printerData.rotate}
              onChange={onRotateChange}
              options={[
                { value: true, label: translate("eva.main.general.yes") },
                { value: false, label: translate("eva.main.general.no") },
              ]}
            />
          </InputWrapper>
        </StyledFlexColumn>
      </FormContainer>
    </OverlayLoader>
  );
}

export default FormView;
